// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"DepartmentFilters_filtersWrapper__9yjqM","filterCTA":"DepartmentFilters_filterCTA__U9-hL"};